import Home from './Home'
import Footer from './Footer'
import './App.css'
import './styles/home.css'
import './styles/topnavbar.css'
import './styles/footer.css'

function App() {
  return (
    <>
      <Home />
      <Footer />
    </>
  )
}

export default App
